import PropTypes from "prop-types"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const TimeRangePicker = ({ dayKey, disabled, dayErrors }) => {
  const { control } = useFormContext()
  return (
    <div className="relative">
      <div className="flex items-center space-x-2">
        <Controller
          name={`${dayKey}.timeRange.start`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Form.TimePicker
              id="startTime"
              onChange={onChange}
              value={value || null}
              disabled={disabled}
              hasErrors={!!dayErrors?.timeRange?.start}
            />
          )}
        />
        <span>to</span>
        <Controller
          name={`${dayKey}.timeRange.end`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Form.TimePicker
              id="endTime"
              onChange={onChange}
              value={value || null}
              disabled={disabled}
              hasErrors={!!dayErrors?.timeRange?.end}
            />
          )}
        />
      </div>
      <div className="absolute -bottom-5 left-0">
        {dayErrors?.timeRange?.start && (
          <Form.Error>{dayErrors.timeRange.start.message}</Form.Error>
        )}
      </div>
      <div className="absolute -bottom-5 right-0">
        {dayErrors?.timeRange?.end?.message && (
          <Form.Error>{dayErrors?.timeRange.end.message}</Form.Error>
        )}
      </div>
    </div>
  )
}

TimeRangePicker.propTypes = {
  dayKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dayErrors: PropTypes.object,
}

export default TimeRangePicker
